import React, { useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { persistor, resetStore } from "../../../../store/store";
import SideBarLogo from "../../../../assets/images/FareTrack-Rebranding.logo.webp";
import SideBarStyles from "./sideBarStyles";
import { setNotificationInfo } from "../../../../services/slices/authTokenSlice";
import "../sidebar.scss";
import NotificationsIcon from '@mui/icons-material/Notifications';
import APIServices from "../../../../services/api-services";
import { endSession } from "../../../../services/http-client";
import { isValue } from "../../../../utils/constants/constants";

const SideBrandInfo = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const anchorElRef = useRef(null);
    const { ipLogUpdate } = APIServices();
    const { fullName } = useSelector((state) => state.authToken.authTokenResponseData);
    const { notificationInfo } = useSelector((state) => (state?.authToken));
    const { containerProps, imageProps } = SideBarStyles();
    const [openNotification, setOpenNotification] = useState(true);
    const admin = useSelector((state) => state.authToken.authTokenResponseData.isBdePanel);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(isValue?.emptyString);
    const controller = useRef(null);
    // Clear all Redex storages
    const clearAllReduxStates = () => {
        return new Promise((resolve) => {
            dispatch(resetStore());
            resolve();
        });
    }

    // Clear redux state values stored
    const purgePersistor = () => {
        return new Promise((resolve) => {
            persistor.purge();
            resolve();
        });
    };

    // Clear session storage
    const clearSessionStorage = () => {
        return new Promise((resolve) => {
            sessionStorage.clear();
            resolve();
        });
    };

    //Clear Local Storage
    const clearLocalStorage = () => {
        return new Promise((resolve) => {
            localStorage.clear();
            resolve();
        });
    };

    const Handlelogout = async () => {
        // Both paths end the server session and clear the httpOnly auth cookies. When /ipupdate fails
        // (network, expired session), /auth/logout still does, so the next login never inherits this session.
        const loggedOut = !admin && await ipLogUpdate({ fullName }, setLoading, setError, controller)
        if (!loggedOut?.status) {
            await endSession()
        }
        clearAllReduxStates();
        purgePersistor();
        clearSessionStorage();
        clearLocalStorage();
        navigate("/", { replace: true });
    }

    const handleClickNotification = () => {
        setOpenNotification(!openNotification);
        dispatch(setNotificationInfo(true));
    };
    return (
        <Box   {...containerProps}>
            <div className="text-center w-100">
                {!!location?.pathname?.includes("mymarket") ?
                    <img src={SideBarLogo} {...imageProps} alt="FareTrack" /> :
                    <Link to="/quick_access" className="text-center w-100">
                        <img src={SideBarLogo} {...imageProps} alt="FareTrack" />
                    </Link>}
            </div>
            <div className="d-flex justyfy-space-between align-center userinfo-notify">
                <div className="welcome-user">
                    <span className="welcome-txt">Welcome</span>
                    <div className="d-grid user-info">
                        <span>{fullName}</span>
                        <Button className="log-out d-flex align-center" label="Logout" onClick={Handlelogout} ><LogoutIcon /> Logout</Button>
                    </div>
                </div>
                <div className=" notify-pos" onClick={handleClickNotification} id="togglernotify">
                    <div className={!notificationInfo ? "pulse cursor-p" : "normal-pulse cursor-p"} ref={anchorElRef}>
                        <NotificationsIcon />
                    </div>
                    {openNotification ? isValue?.emptyString : <></>}
                </div>
            </div>
        </Box>
    )
}

export default SideBrandInfo;